export default "__VITE_ASSET__DOP6sVva__"